module.exports = "/_next/static/images/AiDrivenCustomer-036f84073aacad9ed3abcd776e894e3a.webp";